class BtnToTop {
	constructor() {
		this.BtnToTop = document.getElementById('btnToTopDondeEstamos');
		this.targetDiv = document.querySelector('.container-custom');

		if (this.BtnToTop && this.targetDiv) {
			this.init();
			/*this.handleScroll();*/
		}
	}

	init() {
		this.BtnToTop.addEventListener('click', () => {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		});

		/*window.addEventListener('scroll', () => this.handleScroll());*/
	}

	/*handleScroll() {
		const rect = this.targetDiv.getBoundingClientRect();
		const windowHeight = window.innerHeight;

		const reachedBottom = rect.bottom <= windowHeight - 31;
		const reachedBottomMultipliThree = rect.bottom <= windowHeight + 31;

		const locationElements = this.targetDiv.querySelectorAll('.location');
		const count = locationElements.length;

		const isMultipleOfThree = count % 3 === 0 && count !== 0;

		if (reachedBottom && !isMultipleOfThree) {
			this.BtnToTop.classList.add('absolute');
		} else if (reachedBottomMultipliThree && isMultipleOfThree) {
			this.BtnToTop.classList.add('absolute-multipli-three-countries');
		} else {
			this.BtnToTop.classList.remove('absolute', 'absolute-multipli-three-countries');
		}
	}*/
}

export default BtnToTop;
